import type { Transition } from "framer-motion";

export const spring = {
  snappy: {
    type: "spring",
    stiffness: 500,
    damping: 28,
    mass: 0.6,
  } satisfies Transition,

  standard: {
    type: "spring",
    stiffness: 380,
    damping: 38,
    mass: 0.8,
  } satisfies Transition,

  gentle: {
    type: "spring",
    stiffness: 260,
    damping: 32,
    mass: 1,
  } satisfies Transition,

  slow: {
    type: "spring",
    stiffness: 180,
    damping: 28,
    mass: 1.2,
  } satisfies Transition,

  bouncy: {
    type: "spring",
    stiffness: 600,
    damping: 20,
    mass: 0.5,
  } satisfies Transition,

  stiff: {
    type: "spring",
    stiffness: 420,
    damping: 45,
    mass: 0.9,
  } satisfies Transition,
} as const;

export const curves = {
  expo: [0.16, 1, 0.3, 1] as [number, number, number, number],

  sharp: [0.22, 1, 0.36, 1] as [number, number, number, number],

  smooth: [0.4, 0, 0.2, 1] as [number, number, number, number],

  enter: [0, 0, 0.2, 1] as [number, number, number, number],

  exit: [0.4, 0, 1, 1] as [number, number, number, number],
} as const;

export const ease = {
  expo: (duration = 0.6, delay = 0): Transition => ({
    duration,
    delay,
    ease: curves.expo,
  }),
  sharp: (duration = 0.5, delay = 0): Transition => ({
    duration,
    delay,
    ease: curves.sharp,
  }),
  smooth: (duration = 0.45, delay = 0): Transition => ({
    duration,
    delay,
    ease: curves.smooth,
  }),
  linear: (duration = 0.3, delay = 0): Transition => ({
    duration,
    delay,
    ease: "linear",
  }),
};

export function reducedMotion(transition: Transition): Transition {
  if (
    typeof window !== "undefined" &&
    window.matchMedia("(prefers-reduced-motion: reduce)").matches
  ) {
    return { duration: 0 };
  }
  return transition;
}